import React from 'react';
import styled from 'styled-components';

function DJSBSideBar({formContext}) {
  const externalReferenceName = formContext.externalReferenceName;

  const Container = styled.div`
    width: 100%;
    margin-bottom: 20px;

    /* Small Smartphone */
    @media (max-width: 480px) {
      position: absolute;
      top: 100px;
      right: 0;
    }

    /* iPad Portrait */
    @media (min-width: 481px) and (max-width: 768px) {
      position: absolute;
      top: 130px;
      right: 0;
    }

    /* iPad Landscape */
    @media (min-width: 769px) and (max-width: 1024px) {
    }
  `;

  const Image = styled.div`
    ${props => props.isDjsbPhysical ? props.theme.djsb?.imagePhysical : props.theme.djsb?.image}
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    display: flex;
  `;

  const ImageText = styled.div`
    ${props => props.isDjsbPhysical ? props.theme.djsb?.imageTextPhysical : props.theme.djsb?.imageText}
    font-family: ${props => props.theme.djsb?.fontFamily};
    font-size: ${props => props.theme.djsb?.fontSize};
    font-weight: ${props => props.theme.djsb?.fontWeight};
    line-height: ${props => props.theme.djsb?.lineHeight};
    text-align: center;
    hyphenate-limit-chars: 6 3 2;
    hyphens: auto;

    @media (max-width: 768px) {
      font-size: ${props => props.theme.djsb?.smallFontSize};
    }
  `;

  const NoImage = styled.div`
    ${props => props.theme.djsb?.noImage}
  `;

  if (!externalReferenceName) {
    return <NoImage />;
  }

  return (
    <Container>
      <Image isDjsbPhysical={formContext.isDjsbPhysical}>
        <ImageText isDjsbPhysical={formContext.isDjsbPhysical}>{externalReferenceName}</ImageText>
      </Image>
    </Container>
  );
}

export default DJSBSideBar;
